export enum BANNER_SEVERITY {
  BLACK = 'Bandeau Noir - Offre commerciale',
  BLUE = 'Bandeau bleu - Informations Fraudes Mineures',
  ORANGE = 'Bandeau Orange - Fraudes en cours - Majeures',
  RED = 'Bandeau Rouge - Incident Majeur',
}

export enum BANNER_SCOPE {
  GLOBAL = 'Tout le site',
  LOCAL = 'Certaines pages',
}

export const BANNERS_PRIORITY_LEVEL = {
  [BANNER_SEVERITY.BLACK]: 0,
  [BANNER_SEVERITY.BLUE]: 1,
  [BANNER_SEVERITY.ORANGE]: 2,
  [BANNER_SEVERITY.RED]: 3,
}

export const getMostSeverBanner = (
  banners: Queries.ContentfulInformationBanner[] = []
) => {
  if (!banners) {
    return null
  }

  let banner = banners[0]
  banners.forEach((b) => {
    if (
      BANNERS_PRIORITY_LEVEL[banner.severity as BANNER_SEVERITY] <
      BANNERS_PRIORITY_LEVEL[b.severity as BANNER_SEVERITY]
    ) {
      banner = b
    }
  })
  return banner
}

export const getBannerForPage = (
  pageId: string,
  banners: Queries.ContentfulInformationBanner[]
) => {
  const bannersRelatedToPage = banners.filter((b) => {
    const isGlobalBanner = b.scope === BANNER_SCOPE.GLOBAL

    if (!b.pageList) {
      return isGlobalBanner
    }

    const pageIndexInList = b.pageList.findIndex(
      (p) => p.contentful_id === pageId
    )
    return isGlobalBanner ? pageIndexInList < 0 : pageIndexInList >= 0
  })

  if (bannersRelatedToPage.length === 0) {
    return null
  }

  const banner = getMostSeverBanner(bannersRelatedToPage)

  return banner
}
